// NOTE on fullscreen / host-URL-sync routes:
//
// If you add a sub-route that needs the presenter's outer URL to mirror
// the iframe's path (or that wants to take over the page in fullscreen
// mode), the host bridge currently can't help directly — `onRouteChange`
// is repurposed for "navigate the parent's router on the embed's
// behalf" (Buy more licenses, leave-team redirect). Mixing both
// semantics on one prop will thrash navigation.
//
// Two ways to add the capability when you need it:
//   1. Add a new bridge prop (e.g. `onChildRouteChange`) on
//      `host/teamAppZoid.ts` + the presenter's `teamAppZoid.js`, then
//      fire it from a `useEffect` on `useLocation()` here.
//   2. Keep one prop but disambiguate via the `fullScreen` field — the
//      host treats fullScreen=true as a child-route sync signal and
//      fullScreen=false as a host-nav request. Slightly clever, but
//      avoids growing the contract.
//
// See packages/frontend/CLAUDE.md for the original convention notes.

import { Navigate, Route, Routes } from "react-router-dom";
import { TeamPage } from "../team/TeamPage";
import { AdminTeamLicensesPage } from "../admin/AdminTeamLicensesPage";

function TeamSettingsStub() {
  return <p style={{ padding: 24 }}>Team settings — coming soon.</p>;
}

function TeamAnalyticsStub() {
  return <p style={{ padding: 24 }}>Team analytics — coming soon.</p>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/team" replace />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/team/settings" element={<TeamSettingsStub />} />
      <Route path="/team/analytics" element={<TeamAnalyticsStub />} />
      {/* CS / staff-only routes, mounted by stpancras-admin-app via zoid.
          Role enforcement is the page's responsibility — see the redirect
          in AdminTeamLicensesPage. The catch-all below would swallow
          unmatched admin URLs into /team, so keep this above it. */}
      <Route
        path="/admin/teams/:accountId"
        element={<AdminTeamLicensesPage />}
      />
      <Route path="*" element={<Navigate to="/team" replace />} />
    </Routes>
  );
}
